import { render, staticRenderFns } from "./TaxonomyNcbiSearch.vue?vue&type=template&id=1c5fb41f&"
import script from "./TaxonomyNcbiSearch.vue?vue&type=script&lang=js&"
export * from "./TaxonomyNcbiSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VTooltip})
